module.exports = __webpack_public_path__ + "img/research_item_2.9603aaed.png";